import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {TextInput, TextInputError} from '../../containers/CheckoutPage/CheckoutPage.style';
import {FormattedMessage} from 'react-intl';

export class RenderTextInput extends PureComponent {
  render() {
    const {input, type, meta: { touched, error }, dataInitializedFromStorage, maxLength} = this.props;
    const renderError = (touched || dataInitializedFromStorage) && error &&
      <TextInputError>
        {
          typeof error === 'string' ?
            <FormattedMessage id={error === 'required' ? `form.${input.name}.required` : error} /> :
            <FormattedMessage
              id={error.name}
              values={error.props}
            />
        }
      </TextInputError>;

    return (
      <div>
        <TextInput
          {...input}
          type={type}
          error={(touched || dataInitializedFromStorage) && !!error}
          maxLength={maxLength}
        />
        {renderError}
      </div>
    );
  }
}

RenderTextInput.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  dataInitializedFromStorage: PropTypes.bool,
  maxLength: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

export default RenderTextInput;



// WEBPACK FOOTER //
// ./components/ReduxForm/RenderTextInput.js